import SecurityCodeAlert from './SecurityCodeAlert';

export default SecurityCodeAlert;
